import { render, staticRenderFns } from "./Art.vue?vue&type=template&id=4b52686c&scoped=true"
import script from "./Art.vue?vue&type=script&lang=js"
export * from "./Art.vue?vue&type=script&lang=js"
import style0 from "./Art.vue?vue&type=style&index=0&id=4b52686c&prod&scoped=true&lang=scss"
import style1 from "./Art.vue?vue&type=style&index=1&id=4b52686c&prod&lang=scss"
import style2 from "./Art.vue?vue&type=style&index=2&id=4b52686c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52686c",
  null
  
)

export default component.exports